<template>
    <div class="bg">
        <div class="title">金沫旅游</div>
        <ul class="clear">

            <li @click="toLogin(2)">
                <i class="el-icon-user"></i>
                <p class="p">采购方入口</p>
            </li>
            <li @click="toLogin(1)">
                <i class="el-icon-user-solid"></i>
                <p class="p">供应商入口</p>
            </li>
            <!-- <li @click="toLogin(3)">
                <i class="el-icon-s-custom"></i>
                <p class="p">专家方入口</p>
            </li>
            <li @click="toLogin(5)">
                <i class="el-icon-user-solid"></i>
                <p class="p">代理商入口</p>
            </li> -->
        </ul>
        <div class="home" @click="toLogin(4)">
            <!-- <i class="el-icon-s-custom"></i> -->
            回到主页
        </div>
    </div>
</template>

<script>
import announcement from "@/api/announcement/announcement"
export default {

    data() {
        return {

        };
    },

    mounted() {
        this.orgInfo()
    },

    methods: {
        toLogin(val) {
            sessionStorage.setItem('loginFlag', val)
            let loginWay = sessionStorage.getItem('loginWay') ? sessionStorage.getItem('loginWay') : 0;
            console.log('loginWay', loginWay, sessionStorage.getItem('loginWay'));

            if (loginWay == 0) {
                switch (val) {
                    case 1:
                        this.$router.push('/login')
                        // let routeData = this.$router.resolve({
                        //     path: '/login'
                        // });
                        // window.open(routeData.href);
                        break;
                    case 2:
                        window.open('http://jcmanage.th.520ban.com/login')
                        break;
                    case 3:
                        // window.open('http://jcmanage.th.520ban.com/login?useType=2')
                        window.open('http://jcmanage.th.520ban.com/login')
                        break;
                    case 4:
                        this.$router.push("/home")
                        break;
                    case 5:
                        // window.open('http://jcmanage.th.520ban.com/login?useType=3')
                        window.open('http://jcmanage.th.520ban.com/login')
                        break;
                    default:
                        break;
                }
            } else {
                switch (val) {
                    case 1:
                        // this.$router.push('/login')
                        let routeData = this.$router.resolve({
                            path: '/register'
                        });
                        window.open(routeData.href, '_blank');
                        break;
                    case 2:
                        // window.open('http://jcmanage.th.520ban.com/login?useType=1&isRegister=1')
                        window.open('http://jcmanage.th.520ban.com/login')

                        break;
                    case 3:
                        // window.open('http://jcmanage.th.520ban.com/login?useType=2&isRegister=1')
                        window.open('http://jcmanage.th.520ban.com/login')

                        // if (!this.$CA.getSignCertInfo()) {
                        //     this.$message.warning("未安装数字证书，或未找到符合License的数字证书");
                        //     return
                        // }else{
                        //     // window.open('http://101.205.145.120:3200/login?useType=2&isRegister=1')

                        // }
                        break;
                    case 4:
                        this.$router.push("/home")
                        break;
                    case 5:
                        // window.open('http://jcmanage.th.520ban.com/login?useType=3&isRegister=1', '_blank')
                        window.open('http://jcmanage.th.520ban.com/login', '_blank')
                        break;
                    default:
                        break;
                }
            }

        },
        //查询当前域名的公司信息window.location.host
        async orgInfo() {
            const res = await announcement.orgInfo({ domains: 'localhost' })
            console.log("查询当前域名的公司信息", res)
            if (res.code == 0) {
                localStorage.setItem("orgInfo", JSON.stringify(res.data))
            }
        },
    },
};
</script>

<style lang="less" scoped>
.home {
    margin-top: 120px;
    font-size: 30px;
    text-decoration: underline;
    cursor: pointer;
    text-align: center;
}

.bg {
    color: #fff;
    width: 100%;
    min-height: 100vh;
    box-sizing: border-box;
    padding: 40px 0 60px;
    background: url(../../assets/images/login_background.png) center center no-repeat;
    background-size: 100% 100%;

    .title {
        text-align: center;
        font-size: 40px;
    }


    .clear {
        width: 60%;
        padding: 0;
        margin: 100px auto 0;
        display: flex;
        justify-content: center;

        li {
            list-style: none;
            color: #ccc;
            width: 150px;
            height: 150px;
            border-radius: 50%;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            margin-left: 30px;
            margin-right: 30px;

            i {
                font-size: 50px;

            }
        }

        li:hover {
            cursor: pointer;
            outline: 5px solid #1f65ba;
            transition: all .1s;
            color: #1f65ba;
        }
    }
}

.is_active {
    outline: 5px solid #1f65ba;
    color: #1f65ba;
}
</style>